import React from "react";
import "./Body.css";
import steel from "./image/Steelcaro.jpeg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import automobile from "./image/Automobile.jpeg";
import Cement from "./image/Cement.jpeg";
import chain from "./image/Chain.jpeg";
import convayr from "./image/Conveyor.jpeg";
import sugar1 from "./image/sugar1.jpg";
import sugar2 from "./image/sugar2.jpg";
import sugar3 from "./image/sugar3.png";
import sugar4 from "./image/sugar4.png";
import sugar5 from "./image/sugar5.jpg";
import sugar6 from "./image/sugar6.png";
import sugar7 from "./image/sugar7.png";
import ome1 from "./image/ome1.jpg";
import ome2 from "./image/ome2.jpg";
import ome3 from "./image/ome3.jpg";
import ome4 from "./image/ome4.jpg";
import ome5 from "./image/ome5.jpg";
import ome6 from "./image/ome6.jpg";
import ome7 from "./image/ome7.jpg";
import ome8 from "./image/ome8.jpg";
import ome9 from "./image/ome9.jpg";
import ome10 from "./image/ome10.jpg";
import ome11 from "./image/ome11.jpg";
import ome12 from "./image/ome12.jpg";
import ome13 from "./image/ome13.jpg";
import ome14 from "./image/ome14.jpg";
import ome15 from "./image/ome15.jpg";
import ome16 from "./image/ome16.jpg";
import cf1 from "./image/cf1.jpg";
import cf2 from "./image/cf2.jpg";
import cf3 from "./image/cf3.jpg";
import cf4 from "./image/cf4.jpg";
import cf5 from "./image/cf5.jpg";
import ec1 from "./image/ec1.jpg";
import ec2 from "./image/ec2.png";
import ec3 from "./image/ec3.png";
import ec4 from "./image/ec4.jpg";
import ec5 from "./image/ec5.png";
import ec6 from "./image/ec6.jpg";
import ec7 from "./image/ec7.jpg";
import ec8 from "./image/ec8.png";
import ec9 from "./image/ec9.png";
import steel1 from "./image/steel1.jpg";
import steel2 from "./image/steel2.jpg";
import steel3 from "./image/steel3.png";
import steel4 from "./image/steel4.png";
import steel5 from "./image/steel5.png";
import cement1 from "./image/cement1.jpg";
import cement2 from "./image/cement2.jpg";
import cement3 from "./image/cement3.jpg";
import cement4 from "./image/cement4.jpg";
import cement5 from "./image/cement5.jpg";
import cement6 from "./image/cement6.jpg";
import cement7 from "./image/cement7.jpg";
import cement8 from "./image/cement8.jpg";
import cement9 from "./image/cement9.jpg";
import { Link } from "react-router-dom";

function Body() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: false,
  };
  const settings1 = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
  };
  const settings2 = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  return (
    <div className="main-container">
      <div className="">
        <Slider {...settings}>
          <div>
            <img src={steel} alt="Slide 2" />
          </div>
          <div>
            <img src={automobile} alt="Slide 2" />
          </div>
          <div>
            <img src={Cement} alt="Slide 3" />
          </div>
          <div>
            <img src={chain} alt="Slide 4" />
          </div>
          <div>
            <img src={convayr} alt="Slide 5" />
          </div>
        </Slider>
      </div>

      <div className="container">
        <div>
          <h3 className="heading">
            <span>“Customized Solution Provider for Industrial Chains”</span>
          </h3>
        </div>

        <div className="para">
          <h3>
            Welcome to Swajit Engineering Pvt ltd- Conveyor chains, slats, and
            scrapers manufacturers and suppliers in Aurangabad, Maharashtra
            India
          </h3>

          <p>
            Swajit Engineering Pvt. Ltd. based at Aurangabad (M.S.), India has
            great pleasure to introduce as India’s No.1 & one of the leading
            Brands with “Customize Solution Provider for Industrial Chains”.
          </p>
          <p>
            Since the inception in 1992; Swajit has emerged as the leading
            manufacturer of all type of Roller Conveyor Chains and any type of
            Link, Pin and Bush Mechanism Heavy Duty Chains for Material Handling
            Systems.
          </p>
          <p>
            Swajit is equipped with the latest technology comprising ‘Stat-of
            -Art-Plant’ with all Infrastructure facilities & processes, advanced
            metallurgical laboratory to manufacture all type of Conveyor chains
            and Sprocket of finest quality.
          </p>
        </div>

        <div className="para2">
          <h3>Why Would You Choose Us?</h3>
          <li>
            We are one of the topmost transmission and conveyor chains
            manufacturers in India.
          </li>
          <li>
            To set international standards, we keep following and updating all
            the ISI specifications while manufacturing the products.
          </li>
          <li>
            With our highly qualified quality controller team, all the products
            are examined by the different parameters to ensure flawless
            performance, premium quality, durability, and cost-effectiveness as
            well.
          </li>
          <li>
            At our company, we prioritize offering rich quality services and
            products to the clients in a given time period.
          </li>
        </div>

        <div className="para33">
          <div>
            <p className="newss">
              <>Infrastructure & Production Capacity</>
            </p>
            <p>
              {" "}
              <b>PRODUCTS: - </b> All types of Steel Conveyor Chains – Bucket
              Elevator, Drag / Flow
              <br />
              Conveyor, Power Transmission Chains, Buckets, Slats, Sprockets
              etc.{" "}
            </p>

            <p>
              <li>PITCH SIZES: – 50 to 750 mm</li>
              <li>BREAKING LOAD CAP. : – UP TO 437.5 TON</li>
              <li>
                CUSTOMERS: – Supplying to around 300 Nos. Sugar Factories, 100
                Nos. Cement & <br />
                Steel plants of India & moreover supplying the Conveyor Chains
                to various Industries like <br />
                Chemical, Fertilizer, Palm Oil, Automobile, paper, Theme Park,
                Waste Water & all major <br />
                OEM’s e.g.- ISGEC, Thermax, ThyssenKrupp, Method, Schenck
                (Redler), Uttam, Meru etc <br />
              </li>
            </p>
          </div>

          <div className="web2">
            <div className="web3">
              <p>PLANT & MACHINERY:</p>

              <li>
                K9- MACHINE SHOP + Corporate office, 30,000 Sq. Feet Area.
              </li>
              <li>K18: – Heat Treatment Shop, 25,000 Sq. Feet Area.</li>
              <li>K19: – Press Shop, 25,000 Sq. Feet Area.</li>
              <li>K20: – Assembly Shop, 25,000 Sq. Feet Area.</li>
              <li>
                G39: – PLC Controlled Case carburizing Heat Treatment Shop,
                15,000 Sq. Feet Area <br />& taken 1,44,000 sq. feet new land
                for expansion
              </li>
            </div>
          </div>
        </div>

        <div className="web">
          <b>
            <p className="web1">
              NEW LAND PROCUREMENT IS GOING ON AROUND 88,000 SQUARE FEET.
            </p>
          </b>

          <p>
            <li>TOTAL MANPOWER: – 250 Nos.</li>
            <li>TURNOVER 2022-23: – INR 105 Cr.</li>
            <li>
              EXPORT: – Philippines, Mauritius, Malaysia, Uganda, Kenya,
              Tanzania, Zambia, Indonesia, Rwanda,Ethiopia, Spain, Jamaica,
              Sudan, Nepal, Vietnam, Oman, <br />
              Thailand, United Kingdom.
            </li>
          </p>
        </div>

        <div className="para3">
          <p className="news">News</p>
          <p>We are working 24 * 7 by maintaning all Covid19 norms..</p>
        </div>

        <div className="main-grid">
          <div className="grid">
            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <p>Sugar Industry</p>
                </div>
                <div class="flip-card-back">
                  <p className="cardp">Sugar Industry</p>
                  <p>
                    Drop Forged Chain Fabricated Carrier Chain Forged Rake
                    Elevator Inter Carrier Chain Slates Sugar Elevator Chain
                  </p>
                </div>
              </div>
            </div>

            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <p>Cement Industry</p>
                </div>
                <div class="flip-card-back">
                  <p className="cardp">Cement Industry</p>
                  <p>
                    Cement Industry Appron Feeder Chain Bucket Elevator Chain
                    Coal Feeder Chain Drag & Flow Conveyor Chain Enmass Conveyor
                    Chain
                  </p>
                </div>
              </div>
            </div>

            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <p>Steel Industry</p>
                </div>
                <div class="flip-card-back">
                  <p className="cardp">Steel Industry</p>
                  <p>
                    Conveyor Chain Cooling Bed Conveyor Draw Bench Chain Mandrel
                    Bar Insert Mandrel Extractor Chain Shell Pusher Chain
                  </p>
                </div>
              </div>
            </div>

            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <p>Chemical & Fertilizer</p>
                </div>
                <div class="flip-card-back">
                  <p className="cardp">Chemical & Fertilizer</p>
                  <p>
                    Bucket Elevator Chain Bucket Elevator Chain Bucket Elevator
                    Chain-G2 Attachment
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid">
            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <p>Heavy Duty Conveyor Equipment Chain</p>
                </div>
                <div class="flip-card-back">
                  <p className="cardp">Heavy Duty Conveyor Equipment Chain</p>
                  <p>Conveyor Chain</p>
                </div>
              </div>
            </div>

            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <p>Automobile Industry</p>
                </div>
                <div class="flip-card-back">
                  <p className="cardp">Automobile Industry</p>
                  <p>
                    Conveyor Chain for Oven Conveyor Chain for Buffer Storage
                    System Conveyor Chain for Car Parking Conveyor Chain for
                    Shower Testing know more
                  </p>
                </div>
              </div>
            </div>

            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <p>Boiler & Thermal Power Plant</p>
                </div>
                <div class="flip-card-back">
                  <p className="cardp">Boiler & Thermal Power Plant</p>
                  <p>Gate Chain Ash Handling Chain</p>
                </div>
              </div>
            </div>

            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <p>Solvent Industry</p>
                </div>
                <div class="flip-card-back">
                  <p className="cardp">Solvent Industry</p>
                  <p>
                    We Bucket Elevator Chain Extractor Chain Drag Chain Flow
                    Conveyor Chain
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr></hr>

        <div className="cont6">
          <p>Clients</p>
        </div>

        <div className="cf1">
          Sugar
          {/* <p>OEM</p> */}
        </div>
        <div className="corouseal1">
          <Slider className="sc1" {...settings1}>
            <Link
              target="_blank"
              to="https://renukasugars.com/environmental-compliance/"
            >
              <div>
                <img src={sugar1} alt="Slid 1" />
              </div>
            </Link>
            <Link target="_blank" to="https://www.baramatiagro.com/">
              <div>
                <img src={sugar2} alt="Slid 2" />
              </div>
            </Link>
            <Link target="_blank" to="https://www.nslsugars.com/">
              <div>
                <img src={sugar3} alt="Slid 3" />
              </div>
            </Link>
            <Link target="_blank" to="https://parrys.com/">
              <div>
                <img src={sugar4} alt="Slid 4" />
              </div>
            </Link>
            <div>
              <img src={sugar5} alt="Slid 5" />
            </div>
            <Link target="_blank" to="https://www.trivenigroup.com/">
              <div>
                <img src={sugar6} alt="Slid 6" />
              </div>
            </Link>
            <Link target="_blank" to="https://www.usipl.com/">
              <div>
                <img src={sugar7} alt="Slid 7" />
              </div>
            </Link>
          </Slider>
          <div className="ome1">OEM</div>
          <Slider className="sc1" {...settings2}>
            <div>
              <img src={ome1} alt="Slid 1" />
            </div>
            <div>
              <img src={ome2} alt="Slid 2" />
            </div>
            <div>
              <img src={ome3} alt="Slid 3" />
            </div>
            <div>
              <img src={ome4} alt="Slid 4" />
            </div>
            <div>
              <img src={ome5} alt="Slid 5" />
            </div>
            <div>
              <img src={ome6} alt="Slid 6" />
            </div>
            <div>
              <img src={ome7} alt="Slid 7" />
            </div>
            <div>
              <img src={ome8} alt="Slid 8" />
            </div>
            <div>
              <img src={ome9} alt="Slid 9" />
            </div>
            <div>
              <img src={ome10} alt="Slid 10" />
            </div>
            <div>
              <img src={ome11} alt="Slid 11" />
            </div>
            <div>
              <img src={ome12} alt="Slid 12" />
            </div>
            <div>
              <img src={ome13} alt="Slid 13" />
            </div>
            <div>
              <img src={ome14} alt="Slid 14" />
            </div>
            <div>
              <img src={ome15} alt="Slid 15" />
            </div>
            <div>
              <img src={ome16} alt="Slid 16" />
            </div>
          </Slider>
        </div>
        <div className="cf2">
          Chemical And Fertilizer
          {/* <p>Export Client</p> */}
        </div>
        <div className="corouseal1">
          <Slider className="sc1" {...settings1}>
            <div>
              <img src={cf1} alt="Slid 1" />
            </div>
            <div>
              <img src={cf2} alt="Slid 2" />
            </div>
            <div>
              <img src={cf3} alt="Slid 3" />
            </div>
            <div>
              <img src={cf4} alt="Slid 4" />
            </div>
            <div>
              <img src={cf5} alt="Slid 5" />
            </div>
          </Slider>
          <div className="ec">Export Client</div>
          <div class="sct2"></div>
          <Slider className="sc1" {...settings2}>
            <div>
              <img src={ec1} alt="Slid 1" />
            </div>
            <div>
              <img src={ec2} alt="Slid 2" />
            </div>
            <div>
              <img src={ec3} alt="Slid 3" />
            </div>
            <div>
              <img src={ec4} alt="Slid 4" />
            </div>
            <div>
              <img src={ec5} alt="Slid 5" />
            </div>
            <div>
              <img src={ec6} alt="Slid 6" />
            </div>
            <div>
              <img src={ec7} alt="Slid 7" />
            </div>
            <div>
              <img src={ec8} alt="Slid 8" />
            </div>
            <div>
              <img src={ec9} alt="Slid 9" />
            </div>
          </Slider>
        </div>
        <div className="cf3">
          Steel
          {/* <p>Cement</p> */}
        </div>
        <div className="corouseal1">
          <Slider className="sc1" {...settings1}>
            <div>
              <img src={steel1} alt="Slid 1" />
            </div>
            <div>
              <img src={steel2} alt="Slid 2" />
            </div>
            <div>
              <img src={steel3} alt="Slid 3" />
            </div>
            <div>
              <img src={steel4} alt="Slid 4" />
            </div>
            <div>
              <img src={steel5} alt="Slid 5" />
            </div>
          </Slider>
          <div className="ce1">Cement</div>

          <Slider className="sc1" {...settings2}>
            <div>
              <img src={cement1} alt="Slid 1" />
            </div>
            <div>
              <img src={cement2} alt="Slid 2" />
            </div>
            <div>
              <img src={cement3} alt="Slid 3" />
            </div>
            <div>
              <img src={cement4} alt="Slid 4" />
            </div>
            <div>
              <img src={cement5} alt="Slid 5" />
            </div>
            <div>
              <img src={cement6} alt="Slid 6" />
            </div>
            <div>
              <img src={cement7} alt="Slid 7" />
            </div>
            <div>
              <img src={cement8} alt="Slid 8" />
            </div>
            <div>
              <img src={cement9} alt="Slid 8" />
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default Body;
